import { Mic, MicOff } from 'lucide-react';
import { Button } from './ui/button';

/**
 * The mic button for any field that can be spoken instead of typed.
 *
 * It lives here because the same button already existed twice on the Add
 * Phrase form, and the AI Generate description makes three. The recording
 * colour, the pulse and the icon swap are defined once so a change to how
 * "listening" looks happens in one place.
 */
const DictateButton = ({ recording, onStart, onStop, testId, label = 'Dictate' }) => (
    <Button
        data-testid={testId}
        type="button"
        aria-label={recording ? 'Stop dictating' : label}
        variant={recording ? 'default' : 'outline'}
        size="icon"
        className={`shrink-0 rounded-full ${
            recording
                ? 'bg-rose-500 hover:bg-rose-600 animate-pulse'
                : 'border-accent text-accent hover:bg-accent hover:text-white'
        }`}
        onClick={recording ? onStop : onStart}
    >
        {recording ? <MicOff className="h-4 w-4" /> : <Mic className="h-4 w-4" />}
    </Button>
);

export default DictateButton;
